// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TagInputController from "./tag_input_controller"
application.register("tag-input", TagInputController)

import TemplateFilterController from "./template_filter_controller"
application.register("template-filter", TemplateFilterController)

import LandingPreviewController from "./landing_preview_controller"
application.register("landing-preview", LandingPreviewController)

import SiteHeaderController from "./site_header_controller"
application.register("site-header", SiteHeaderController)
